var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99011 2.585C9.40261 1.74917 10.5951 1.74917 11.0076 2.585L12.9726 6.56667L17.3668 7.205C18.2893 7.33834 18.6576 8.47334 17.9901 9.12417L14.8101 12.2233L15.5609 16.5983C15.7193 17.5183 14.7543 18.2192 13.9284 17.785L9.99844 15.7183L6.06927 17.785C5.24427 18.2183 4.27927 17.5183 4.43594 16.5992L5.18677 12.2233L2.00761 9.12334C1.34011 8.47334 1.70844 7.33917 2.63094 7.205L7.02511 6.56667L8.99011 2.585ZM9.99844 3.36584L8.11677 7.17834C8.03614 7.34193 7.91694 7.48346 7.76944 7.59075C7.62195 7.69803 7.45058 7.76784 7.27011 7.79417L3.06177 8.40584L6.10677 11.3742C6.37177 11.6325 6.49261 12.005 6.43011 12.37L5.71177 16.5608L9.47511 14.5817C9.63662 14.4967 9.81637 14.4523 9.99886 14.4523C10.1813 14.4523 10.3611 14.4967 10.5226 14.5817L14.2859 16.5608L13.5676 12.3692C13.5369 12.1895 13.5503 12.0051 13.6066 11.8318C13.6629 11.6585 13.7605 11.5014 13.8909 11.3742L16.9359 8.40584L12.7276 7.79417C12.5471 7.76784 12.3758 7.69803 12.2283 7.59075C12.0808 7.48346 11.9616 7.34193 11.8809 7.17834L9.99844 3.36667V3.36584Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.99e6605ca346e95fdf1d1d16eaa55d67.svg";
export { ForwardRef as ReactComponent };